import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    entryHeader: {
      color: primary.dark,
      fontSize: 14
    },
    button: {
      textTransform: "initial",
      marginTop: 5,
      marginRight: 5,
      width: 103,
      height: 36,
      fontSize: 14
    },
    buttonActive: {
      backgroundColor: secondary.main,
      "&:hover": {
        backgroundColor: secondary.main
      }
    }
  };
});
